import { useState } from 'react';
import { openRegisterLink, resolveBrandNameFromUrl } from '@/utils/trackRegisterClick';

export default function RankingList() {
  const [showMore, setShowMore] = useState(false);

  const initialCasinos = [
    {
      rank: 1,
      name: '💎 IPAY9VIP',
      logo: '/casinoLogo/ipay9vip.png',
      bonus: 'Pokies Bonus 100% + Register Free $10',
      rating: '4.98',
      url:'https://www.ipay9aud.co/en-au/?ref=IPAY9C9C43',
      disclaimer: 'Approved ✅ | 18+. VIP-focused version of iPay9 with extra VIP benefits, smoother game sessions, and a safer payment system for Australian players. Min deposit A$10. Please play responsibly and review full T&Cs.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 2,
      name: '💎 MRBOOM9',
      logo: '/casinoLogo/mrboom9.png',
      bonus: 'Register Free $99.99 + Apps Daily $20',
      rating: '4.97',
      url:'https://mrboom9.com/RFPPOKINOMICS',
      disclaimer: 'Approved ✅ | 18+. Built for Australian players. Pagcor & Curacao Gaming Authority (CGA). HD gameplay, smooth sessions, secure payments, expanding new-game catalogue. Min deposit A$10. Play responsibly. Full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 3,
      name: '💎 IPAY9',
      logo: '/casinoLogo/ipay9.png',
      bonus: 'Monthly Deposit Ranking $1999',
      rating: '4.97',
      url:'https://i9aud.net/RFPOKINOMICS1',
      disclaimer: 'Approved ✅ | 18+. Licensed under Pagcor & Curacao Gaming Authority (CGA) (Licence No. 8048/JAZ). Min deposit A$10. Extra Bonus up to A$113 with no fees. Deposit A$30 to earn a chance on the Fortune Wheel. Please Gamble Responsibly – full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 4,
      name: '💎 KINGBET9',
      logo: '/casinoLogo/kingbet9.png',
      bonus: 'Slot Daily Bns 39% + Missions Get $100',
      rating: '4.96',
      url:'https://kingbett9.com/RFPOKINOMICS13',
      disclaimer: 'Approved ✅ | 18+. Available for Australian players. Operated under Pagcor & Curacao licence No. 8048/JAZ. Min deposit A$10. New register can get welcome bonus 100% and daily rebate up to 5%. Play responsibly. Full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 5,
      name: '💎 BIGPAY77',
      logo: '/casinoLogo/bp77.png',
      bonus: '80% Welcome Bonus + 7% Weekly Rebate',
      rating: '4.96',
      url:'https://bigpay77.co/RFBPOKINOMICS',
      disclaimer: 'Approved ✅ | 18+. Available for Australia-based users. Licensed by Pagcor & Curacao Gaming Authority (CGA) (8048/JAZ). Extra bonus up to A$43 with no fees. Daily check-ins earn points for big prizes. Responsible gaming policy in effect. Full terms and conditions apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 6,
      name: '💎 ME99',
      logo: '/casinoLogo/me99.png',
      bonus: 'JILI Welcome Bns 80% + $1999 Deposit Ranking',
      rating: '4.91',
      url:'https://me99aus.net/RFPOKINOMICSME',
      disclaimer: 'Approved ✅ | 18+. Available to new players from Australia. Licensed and regulated by Pagcor & Curacao Gaming Authority (CGA). Min deposit A$10. 40x wagering applies to bonus and spin winnings. Play responsibly.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 7,
      name: '💎 ROLEX9',
      logo: '/casinoLogo/rolex9.png',
      bonus: 'Register Free Credit A$99.99 + Daily Free $20',
      rating: '4.89',
      url:'https://rolex9au.com/RFPOKINOMICSS',
      disclaimer: 'Approved ✅ | 18+. Australian players welcome. Operated under Pagcor & Curacao licence. Deposit minimum A$10 applies. Random second withdraw bonus. Responsible play encouraged. Full bonus terms apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    }
  ];

  const additionalCasinos = [
    {
      rank: 8,
      name: '💎 GUCCI9',
      logo: '/casinoLogo/gucci9.png',
      bonus: 'Deposit Bonus 50% + Slot Daily Bonus 20%',
      rating: '4.85',
      url:'https://gucci9au.org/RFPOKINOMICSG',
      disclaimer: 'Approved ✅ | 18+. Licensed under Pagcor & Curacao Gaming Authority (CGA). Min deposit A$10. Slot welcome bonus 50% & 20% daily bonus. Responsible gaming applies. Full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 9,
      name: '💎 WINNIE777',
      logo: '/casinoLogo/winnie777.png',
      bonus: 'Up to $194 Share Bonus + Random Daily Free ?',
      rating: '4.76',
      url:'https://winnie777.net/RFPOKINOMICSWI',
      disclaimer: 'Approved ✅ | 18+. Available for Australian players. Operated under Pagcor & Curacao licence No. 8048/JAZ. Min deposit A$10. Bonus funds subject to 45× wagering. Play responsibly.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 10,
      name: '💎 MICKY9',
      logo: '/casinoLogo/micky9.png',
      bonus: 'Free Credit $103.33 + Free Share Bns',
      rating: '4.73',
      url:'https://micky9.net/RFPOKINOMICSMI',
      disclaimer: 'Approved ✅ | 18+. Available for Australia-based users. Licensed by Pagcor & Curacao Gaming Authority (CGA). Bonus and spin winnings subject to 35x wagering. Responsible gaming policy in effect and T&C apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 11,
      name: '💎 MRBEAN9',
      logo: '/casinoLogo/mrbean9.png',
      bonus: 'Special Welcome Bonus 200% + Daily Free $15',
      rating: '4.81',
      url:'https://mrbean9au.com/RFPOKINOMICSM',
      disclaimer: 'Approved ✅ | 18+. Available to new players from Australia. Licensed and regulated by Pagcor & Curacao Gaming Authority (CGA). Min deposit A$10. Deposit A$30 get 1 lucky wheel token. Responsible gaming applies. Full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 12,
      name: '💎 BYBID9',
      logo: '/casinoLogo/bybid9.png',
      bonus: 'Upto $130 Share Bns + Daily Missions $100',
      rating: '4.83',
      url:'https://bybid9.net/RFPOKINOMICS',
      disclaimer: 'Approved ✅ | 18+. Licensed under Pagcor & Curacao Gaming Authority (CGA). Min deposit A$10. Grand jackpot up to A$5088. Deposit A$30 can get one spin whel token. Play responsibly. Full terms apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 13,
      name: '💎 Spinaroo',
      logo: '/casinoLogo/spinaroo.png',
      bonus: 'Daily Slot Bns 80% + Daily Bns $100',
      rating: '4.84',
      url:'https://spinarooaus.com/RFPOKINOMICSP',
      disclaimer: 'Approved ✅ | 18+. Licensed under Pagcor & Curacao Gaming Authority (CGA). Min deposit A$8. Bonus funds and free spin winnings subject to 40× wagering. Responsible gaming applies. Full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    },
    {
      rank: 14,
      name: '💎 QUEEN13',
      logo: '/casinoLogo/queen13.png',
      bonus: 'New Register Free $113 + Daily Free $5',
      rating: '4.73',
      url:'https://queen13au.com/RFPOKINOMICSQU',
      disclaimer: 'Approved ✅ | 18+. Licensed under Pagcor & Curacao Gaming Authority (CGA). Min deposit A$10. Bonus funds and free spin winnings subject to 45× wagering. Responsible gaming applies. Full T&Cs apply.',
      paymentMethods: ['visa', 'master', 'apple', 'google', 'payid', 'osko', 'amopay']
    }
  ];

  const displayedCasinos = showMore ? [...initialCasinos, ...additionalCasinos] : initialCasinos;
  const sortedCasinos = [...displayedCasinos].sort((a, b) => a.rank - b.rank);

  const paymentIcons: Record<string, string> = {
    visa: '/payment/visa.png',
    master: '/payment/master.png',
    apple: '/payment/apple.png',
    google: '/payment/google.png',
    osko: '/payment/osko.png',
    amopay: '/payment/amopay.png',
    payid:'/payment/payid.png',
    speedpay:'payment/speedpay.png',
  };

  return (
    <section id="recommended-casino" className="py-8 md:py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-xl md:text-4xl font-bold text-gray-900 mb-6 md:mb-12 text-center">
          The Popular Online E-Wallet Casinos for Australian Players
        </h1>

        <div className="space-y-4">
          {sortedCasinos.map((casino) => (
            <div
              key={casino.rank}
              className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Desktop Layout with Column Separators */}
              <div className="hidden md:flex items-center p-6">
                {/* Column 1: Logo with Badge + Name */}
                <div className="flex items-center space-x-4 pr-6 border-r border-gray-200" style={{ width: '28%' }}>
                  <div className="relative flex-shrink-0">
                    <div className="w-20 h-20 flex items-center justify-center overflow-hidden">
                      <img src={casino.logo} alt={casino.name} className="w-full h-full object-contain" />
                    </div>
                    <div className="absolute -top-1 -left-1 w-8 h-8 bg-[#1e3a8a] rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md">
                      {casino.rank}
                    </div>
                  </div>
                  <span className="font-bold text-gray-800 text-xl">{casino.name}</span>
                </div>

                {/* Column 2: Bonus Info */}
                <div className="px-6 border-r border-gray-200" style={{ width: '28%' }}>
                  <p className="text-lg text-gray-800 font-bold">{casino.bonus}</p>
                </div>

                {/* Column 3: Rating */}
                <div className="px-6 border-r border-gray-200 text-center" style={{ width: '16%' }}>
                  <div className="inline-flex items-center space-x-1">
                    <span className="text-2xl font-bold text-[#1e3a8a]">{casino.rating}</span>
                    <span className="text-gray-500">/5</span>
                  </div>
                </div>

                {/* Column 4: CTA Button & Payment Methods */}
                <div className="pl-6 flex flex-col items-center space-y-3" style={{ width: '28%' }}>
                  <button 
                    onClick={() => openRegisterLink({
                      section: 'ranking_list_desktop',
                      brandName: resolveBrandNameFromUrl(casino.url, casino.name),
                      url: casino.url,
                    })}
                    className="bg-[#dc2626] hover:bg-[#b91c1c] text-white px-8 py-3 rounded-md font-semibold text-sm whitespace-nowrap transition-colors cursor-pointer w-full max-w-[200px]"
                  >
                    Play Now
                  </button>
                  <div className="flex items-center space-x-2">
                    {casino.paymentMethods.map((method) => (
                      <img
                        key={method}
                        src={paymentIcons[method]}
                        alt={method}
                        className="w-8 h-8 object-contain"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Mobile Layout */}
              <div className="md:hidden p-4">
                <div className="flex items-start space-x-3 mb-4">
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 flex items-center justify-center overflow-hidden">
                      <img src={casino.logo} alt={casino.name} className="w-full h-full object-contain" />
                    </div>
                    <div className="absolute -top-1 -left-1 w-7 h-7 bg-[#1e3a8a] rounded-full flex items-center justify-center text-white font-bold text-xs shadow-md">
                      {casino.rank}
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-800 text-lg mb-1">{casino.name}</h3>
                    <p className="text-sm text-gray-800 font-bold mb-2">{casino.bonus}</p>
                    <div className="flex items-center space-x-1">
                      <span className="text-xl font-bold text-[#1e3a8a]">{casino.rating}</span>
                      <span className="text-gray-500 text-sm">/5</span>
                    </div>
                  </div>
                </div>

                <button 
                  onClick={() => openRegisterLink({
                    section: 'ranking_list_mobile',
                    brandName: resolveBrandNameFromUrl(casino.url, casino.name),
                    url: casino.url,
                  })}
                  className="bg-[#dc2626] hover:bg-[#b91c1c] text-white px-6 py-3 rounded-md font-semibold text-sm whitespace-nowrap transition-colors cursor-pointer w-full mb-3"
                >
                  Play Now
                </button>

                <div className="flex items-center space-x-2 mb-4">
                  {casino.paymentMethods.map((method) => (
                    <img
                      key={method}
                      src={paymentIcons[method]}
                      alt={method}
                      className="w-8 h-8 object-contain"
                    />
                  ))}
                </div>
              </div>

              {/* Disclaimer (Both Desktop & Mobile) */}
              <div className="px-6 pb-4">
                <p className="text-xs text-gray-500 leading-relaxed">{casino.disclaimer}</p>
              </div>
            </div>
          ))}
        </div>

        {!showMore && (
          <div className="text-center mt-8">
            <button 
              onClick={() => setShowMore(true)}
              className="bg-[#1e3a8a] hover:bg-[#1e40af] text-white px-8 py-3 rounded-md font-semibold transition-colors cursor-pointer"
            >
              Show More Casinos
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
